var map = {
	"./1.svg": "c2e0",
	"./2.svg": "3c23",
	"./3.svg": "386b",
	"./4.svg": "ae9a",
	"./5.svg": "ae3a",
	"./6.svg": "c43c",
	"./7.svg": "8a4d",
	"./8.svg": "ccc9",
	"./9.svg": "f646"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46c4";